import * as fb from "../../Firebase/firebase";
import { db, auth, firebase } from "../../Firebase/firebase";
import router from "../../router/router";

export default {
  namespaced: true,

  state: {
    isLoggingIn: false,
    errors: "",
    userProfile: "",
    updatingCompany: false,
    updatingPassword: false,
  },

  getters: {},

  mutations: {
    IS_LOOGING_IN(state, status) {
      state.isLoggingIn = status;
    },
    LOGIN_ERROR(state, messaage) {
      state.errors = messaage;
    },
    setUserProfile(state, data) {
      state.userProfile = data;
    },
    UPDATING_COMPANY(state, status) {
      state.updatingCompany = status;
    },
    UPDATING_PASSWORD(state, status) {
      state.updatingPassword = status;
    },
    REDIRECT(state, { name, time = 0 }) {
      setTimeout(() => {
        router.push({ name });
      }, time);
    },
  },

  actions: {
    async login({ dispatch, commit }, form) {
      // sign user in
      commit("IS_LOOGING_IN", true);
      return fb.auth
        .signInWithEmailAndPassword(form.company, form.password)
        .then((response) => {
          const { user } = response;
          dispatch("fetchUserProfile", user).then(() => {
            commit("IS_LOOGING_IN", false);
            commit("REDIRECT",{name:"dashboard",time:2000});
          });
        })
        .catch((err) => {
          commit("LOGIN_ERROR", err.message);
          commit("IS_LOOGING_IN", false);
        });

      // fetch user profile and set in state
    },
    anonSignup({ dispatch, commit }) {
      fb.auth
        .signInAnonymously()
        .then((response) => {
          const { user } = response;
          dispatch("getCustomersFcmToken", user.uid);
        })
        .catch((err) => {});
    },
    
    async signup({ dispatch, commit }, form) {
      // sign user up
      commit("IS_LOOGING_IN", true);
      fb.auth
        .createUserWithEmailAndPassword(form.company_email, form.password)
        .then((response) => {
          const { user } = response;
          db.collection("users")
            .doc(user.uid)
            .set({
              company_name: form.company_name,
              username: form.company_name.replace(/ /g, "").toLowerCase(),
              logo: [],
              email: form.company_email,
            })
            .then((response) => {
              const user=auth.currentUser
              dispatch("fetchUserProfile", user).then(() => {
                commit("IS_LOOGING_IN", false);
                 dispatch("getFcmToken", user.uid);
                commit("REDIRECT",{name:"dashboard",time:2000});
                //router.push("/dashboard")
              });
            });
        })
        .catch((err) => {
          commit("LOGIN_ERROR", err.message);
          commit("IS_LOOGING_IN", false);
        });
    },
    async fetchUserProfile({ commit }, user) {
      // fetch user profile
      const userProfile = await db
        .collection("users")
        .doc(user.uid)
        .get();

      // set user profile in state
      commit("setUserProfile", userProfile.data());
      return userProfile.data();
      // change route to dashboard
    },

    async updateLogo({ commit, dispatch }, logo) {
      const urlArray = await dispatch("Menu/getUrlArray", logo, { root: true });
      db.collection("users")
        .doc(auth.currentUser.uid)
        .update({ logo: urlArray });
    },

    async updateCompany({ commit, dispatch }, data) {
      commit("UPDATING_COMPANY", true);
      const { name, email, number, address } = data;
      await auth.currentUser.updateEmail(email);
      db.collection("users")
        .doc(auth.currentUser.uid)
        .update({
          company_name: name,
          email,
          address,
          number,
          username,
        })
        .then(() => {
          commit("UPDATING_COMPANY", false);
        });
    },

    async changePassword({ commit, dispatch }, password) {
      commit("UPDATING_PASSWORD", true);
      await auth.currentUser.updatePassword(password).then(() => {
        commit("UPDATING_PASSWORD", false);
      });
    },

    async logout({ commit }) {
      await fb.auth.signOut();

      // clear userProfile and redirect to /login
      commit("setUserProfile", {});
      // router.push({path:'/login'});
    },

    setTokenSentToServer(sent) {
      return window.localStorage.setItem("sentToServer", sent ? "1" : "0");
    },

    async getFcmToken({ commit, dispatch }, auid) {
      if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();
        messaging.usePublicVapidKey(
          "BCApDlAheSEF1wKZuzrLeacVW2wlhKiRr7b4Ei626Y6Dv8bi-ATAa5yPhXNh2nAQslSatdhXyX38fkZ8Lm_Fjvc"
        );

        messaging
          .getToken()
          .then((currentToken) => {
            if (currentToken) {
              //sendTokenToServer(currentToken);
              // updateUIForPushEnabled(currentToken);

              db.collection("users")
                .doc(auid)
                .update({
                  fcmToken: currentToken,
                })
                .then(() => {
                  //dispatch({ type: "FCMTOKEN_SUCCESS" });
                });
            } else {
              // Show permission request.
              // Show permission UI.
              //updateUIForPushPermissionRequired();
              //setTokenSentToServer(false);
              dispatch("setTokenSentToServer", false);

              // Show permission UI.
            }
          })
          .catch((err) => {
            // dispatch({ type: "FCMTOKEN_ERROR" });
            //showToken("Error retrieving Instance ID token. ", err);
            //setTokenSentToServer(false);
            dispatch("setTokenSentToServer", false);
          });

        messaging.onTokenRefresh(() => {
          messaging
            .getToken()
            .then((refreshedToken) => {
              db.collection("users")
                .doc(auid)
                .update({
                  fcmToken: refreshedToken,
                })
                .then(() => {
                  //dispatch({ type: "FCMTOKEN_SUCCESS" });
                });
            })
            .catch((err) => {
              //showToken('Unable to retrieve refreshed token ', err);
            });
        });
      }
    },

    async getCustomersFcmToken({ commit, dispatch }, auid) {
      if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();
        messaging.usePublicVapidKey(
          "BCApDlAheSEF1wKZuzrLeacVW2wlhKiRr7b4Ei626Y6Dv8bi-ATAa5yPhXNh2nAQslSatdhXyX38fkZ8Lm_Fjvc"
        );

        messaging
          .getToken()
          .then((currentToken) => {
            if (currentToken) {
              //sendTokenToServer(currentToken);
              // updateUIForPushEnabled(currentToken);

              db.collection("customers")
                .doc(auid)
                .update({
                  fcmToken: currentToken,
                })
                .then(() => {
                  //dispatch({ type: "FCMTOKEN_SUCCESS" });
                });
            } else {
              // Show permission request.
              // Show permission UI.
              //updateUIForPushPermissionRequired();
              //setTokenSentToServer(false);
              dispatch("setTokenSentToServer", false);

              // Show permission UI.
            }
          })
          .catch((err) => {
            // dispatch({ type: "FCMTOKEN_ERROR" });
            //showToken("Error retrieving Instance ID token. ", err);
            //setTokenSentToServer(false);
            dispatch("setTokenSentToServer", false);
          });

        messaging.onTokenRefresh(() => {
          messaging
            .getToken()
            .then((refreshedToken) => {
              db.collection("customers")
                .doc(auid)
                .update({
                  fcmToken: refreshedToken,
                })
                .then(() => {
                  //dispatch({ type: "FCMTOKEN_SUCCESS" });
                });
            })
            .catch((err) => {
              //showToken('Unable to retrieve refreshed token ', err);
            });
        });
      }
    },
  },
};
